import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ConfirmationComponent } from './confirmation.component';
import { MarkdownModule } from 'ngx-markdown';
import { GenericTilesModule } from '../generic-tiles/generic-tiles.module';

import {
  AnchorModule,
  ButtonModule,
  IconModule,
  ModalModule,
  VmThemeProviderModule,
  ConnectedOverlayModule,
  TypeModule,
} from '@virginmediao2/momentum-angular';
import { IconPipe } from '@/shared/pipes/icon.pipe';
import { LiveChatV3Module } from '@/shared/directives/live-chat-v3';
import { WINDOW } from '@/shared/tokens/window.token';
import { LiveChatService } from '@/shared/services/live-chat.service';
import { AnalyticsCTADirective } from '@/shared/directives/analytics-cta.directive';

@NgModule({
  declarations: [ConfirmationComponent],
  exports: [ConfirmationComponent],
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule,
    AnchorModule,
    ModalModule,
    MarkdownModule,
    LiveChatV3Module,
    GenericTilesModule,
    IconModule,
    IconPipe,
    VmThemeProviderModule,
    ConnectedOverlayModule,
    AnalyticsCTADirective,
    TypeModule,
  ],
  providers: [LiveChatService, { provide: WINDOW, useValue: window }],
})
export class ConfirmationModule {}
